import React from 'react';
import block from 'bem-cn';
import './TableHead.scss';

const TableHead = ({ items, locale }) => {
  const b = block('table-head-general');

  return (
    <thead className={b()}>
      <tr className={b('main-table-head')}>
        {items?.map(el => (
          <th key={el} className={b('table-head')}>
            {locale[el]}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHead;
